/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeactivateUser200,
  InviteUser200,
  InviteUserRequest,
  ListActionTokens200,
  ListActionTokensParams,
  ListUsersParams,
  PagedResponseUserResponse,
  ReactivateUser200,
  ResendInvite200,
  RevokeUserTokens200,
  SearchUsersParams,
  SendPasswordReset200,
  SetInitialPassword200,
  SetInitialPasswordBody,
  UpdateRole200,
  UpdateRoleRequest,
  UserResponse
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List users — own org for org admin, all (or filtered) for app admin — includes last login time
 */
export const listUsers = (
    params?: ListUsersParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<UserResponse[]>(
      {url: `/api/v1/users`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/api/v1/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = unknown>(params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = unknown


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = unknown>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = unknown>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = unknown>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List users — own org for org admin, all (or filtered) for app admin — includes last login time
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = unknown>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Invite a new USER into an existing organisation
 */
export const inviteUser = (
    inviteUserRequest: InviteUserRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<InviteUser200>(
      {url: `/api/v1/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteUserRequest, signal
    },
      );
    }
  


export const getInviteUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: InviteUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: InviteUserRequest}, TContext> => {

const mutationKey = ['inviteUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteUser>>, {data: InviteUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  inviteUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteUserMutationResult = NonNullable<Awaited<ReturnType<typeof inviteUser>>>
    export type InviteUserMutationBody = InviteUserRequest
    export type InviteUserMutationError = unknown

    /**
 * @summary Invite a new USER into an existing organisation
 */
export const useInviteUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: InviteUserRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteUser>>,
        TError,
        {data: InviteUserRequest},
        TContext
      > => {

      const mutationOptions = getInviteUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Admin sets a user's (initial) password directly — the user is forced to change it on next login
 */
export const setInitialPassword = (
    id: string,
    setInitialPasswordBody: SetInitialPasswordBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<SetInitialPassword200>(
      {url: `/api/v1/users/${id}/set-initial-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setInitialPasswordBody, signal
    },
      );
    }
  


export const getSetInitialPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setInitialPassword>>, TError,{id: string;data: SetInitialPasswordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setInitialPassword>>, TError,{id: string;data: SetInitialPasswordBody}, TContext> => {

const mutationKey = ['setInitialPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setInitialPassword>>, {id: string;data: SetInitialPasswordBody}> = (props) => {
          const {id,data} = props ?? {};

          return  setInitialPassword(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetInitialPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof setInitialPassword>>>
    export type SetInitialPasswordMutationBody = SetInitialPasswordBody
    export type SetInitialPasswordMutationError = unknown

    /**
 * @summary Admin sets a user's (initial) password directly — the user is forced to change it on next login
 */
export const useSetInitialPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setInitialPassword>>, TError,{id: string;data: SetInitialPasswordBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setInitialPassword>>,
        TError,
        {id: string;data: SetInitialPasswordBody},
        TContext
      > => {

      const mutationOptions = getSetInitialPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Admin-triggered password reset email for a user
 */
export const sendPasswordReset = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<SendPasswordReset200>(
      {url: `/api/v1/users/${id}/send-password-reset`, method: 'POST', signal
    },
      );
    }
  


export const getSendPasswordResetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPasswordReset>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendPasswordReset>>, TError,{id: string}, TContext> => {

const mutationKey = ['sendPasswordReset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPasswordReset>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sendPasswordReset(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof sendPasswordReset>>>
    
    export type SendPasswordResetMutationError = unknown

    /**
 * @summary Admin-triggered password reset email for a user
 */
export const useSendPasswordReset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPasswordReset>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendPasswordReset>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSendPasswordResetMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Immediately revoke all of a user's access/refresh tokens, without deactivating the account
 */
export const revokeUserTokens = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RevokeUserTokens200>(
      {url: `/api/v1/users/${id}/revoke-tokens`, method: 'POST', signal
    },
      );
    }
  


export const getRevokeUserTokensMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeUserTokens>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeUserTokens>>, TError,{id: string}, TContext> => {

const mutationKey = ['revokeUserTokens'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeUserTokens>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  revokeUserTokens(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeUserTokensMutationResult = NonNullable<Awaited<ReturnType<typeof revokeUserTokens>>>
    
    export type RevokeUserTokensMutationError = unknown

    /**
 * @summary Immediately revoke all of a user's access/refresh tokens, without deactivating the account
 */
export const useRevokeUserTokens = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeUserTokens>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeUserTokens>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRevokeUserTokensMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reissue an invite token and resend the invite email for a user who hasn't accepted yet
 */
export const resendInvite = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ResendInvite200>(
      {url: `/api/v1/users/${id}/resend-invite`, method: 'POST', signal
    },
      );
    }
  


export const getResendInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{id: string}, TContext> => {

const mutationKey = ['resendInvite'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInvite>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  resendInvite(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendInviteMutationResult = NonNullable<Awaited<ReturnType<typeof resendInvite>>>
    
    export type ResendInviteMutationError = unknown

    /**
 * @summary Reissue an invite token and resend the invite email for a user who hasn't accepted yet
 */
export const useResendInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendInvite>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getResendInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Change a user's role
 */
export const updateRole = (
    id: string,
    updateRoleRequest: UpdateRoleRequest,
 ) => {
      
      
      return apiClient<UpdateRole200>(
      {url: `/api/v1/users/${id}/role`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateRoleRequest
    },
      );
    }
  


export const getUpdateRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleRequest}, TContext> => {

const mutationKey = ['updateRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRole>>, {id: string;data: UpdateRoleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRole(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>
    export type UpdateRoleMutationBody = UpdateRoleRequest
    export type UpdateRoleMutationError = unknown

    /**
 * @summary Change a user's role
 */
export const useUpdateRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRole>>,
        TError,
        {id: string;data: UpdateRoleRequest},
        TContext
      > => {

      const mutationOptions = getUpdateRoleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Restore a deactivated user
 */
export const reactivateUser = (
    id: string,
 ) => {
      
      
      return apiClient<ReactivateUser200>(
      {url: `/api/v1/users/${id}/reactivate`, method: 'PATCH'
    },
      );
    }
  


export const getReactivateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateUser>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reactivateUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['reactivateUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reactivateUser(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReactivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateUser>>>
    
    export type ReactivateUserMutationError = unknown

    /**
 * @summary Restore a deactivated user
 */
export const useReactivateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateUser>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivateUser>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getReactivateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deactivate a user (soft delete)
 */
export const deactivateUser = (
    id: string,
 ) => {
      
      
      return apiClient<DeactivateUser200>(
      {url: `/api/v1/users/${id}/deactivate`, method: 'PATCH'
    },
      );
    }
  


export const getDeactivateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateUser(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateUser>>>
    
    export type DeactivateUserMutationError = unknown

    /**
 * @summary Deactivate a user (soft delete)
 */
export const useDeactivateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateUser>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Paginated, filterable user list for admin/roles list pages
 */
export const searchUsers = (
    params?: SearchUsersParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseUserResponse>(
      {url: `/api/v1/users/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchUsersQueryKey = (params?: SearchUsersParams,) => {
    return [
    `/api/v1/users/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchUsersQueryOptions = <TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsers>>> = ({ signal }) => searchUsers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>
export type SearchUsersQueryError = unknown


export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(
 params: undefined |  SearchUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsers>>,
          TError,
          Awaited<ReturnType<typeof searchUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(
 params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsers>>,
          TError,
          Awaited<ReturnType<typeof searchUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(
 params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable user list for admin/roles list pages
 */

export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = unknown>(
 params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List pending/past invites or password-reset requests
 */
export const listActionTokens = (
    params: ListActionTokensParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ListActionTokens200>(
      {url: `/api/v1/users/action-tokens`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListActionTokensQueryKey = (params?: ListActionTokensParams,) => {
    return [
    `/api/v1/users/action-tokens`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListActionTokensQueryOptions = <TData = Awaited<ReturnType<typeof listActionTokens>>, TError = unknown>(params: ListActionTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActionTokens>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActionTokensQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionTokens>>> = ({ signal }) => listActionTokens(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActionTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActionTokensQueryResult = NonNullable<Awaited<ReturnType<typeof listActionTokens>>>
export type ListActionTokensQueryError = unknown


export function useListActionTokens<TData = Awaited<ReturnType<typeof listActionTokens>>, TError = unknown>(
 params: ListActionTokensParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActionTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionTokens>>,
          TError,
          Awaited<ReturnType<typeof listActionTokens>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActionTokens<TData = Awaited<ReturnType<typeof listActionTokens>>, TError = unknown>(
 params: ListActionTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActionTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionTokens>>,
          TError,
          Awaited<ReturnType<typeof listActionTokens>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActionTokens<TData = Awaited<ReturnType<typeof listActionTokens>>, TError = unknown>(
 params: ListActionTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActionTokens>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List pending/past invites or password-reset requests
 */

export function useListActionTokens<TData = Awaited<ReturnType<typeof listActionTokens>>, TError = unknown>(
 params: ListActionTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActionTokens>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActionTokensQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




